import { Order } from '@mc/api'

// Kept out of the module barrel: the state machine imports this.
export const hasCertificateTierPurchase = (order?: Order) =>
  !!order?.products?.some(
    (product) =>
      product.grantsCertificatePass || product.grantsCertificateCredit,
  )
